// App.js
import React, { useState, useContext } from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Cart from "./pages/Cart";
import SearchResults from "./pages/SearchResults";
import BrandList from "./components/BrandList";
import BrandProducts from "./pages/BrandProducts";
import FloatingCartButton from "./components/FloatingCartButton";
import { CartContext } from "./context/CartContext";
import ProductPage from "./pages/ProductPage";
import CategoryPage from "./pages/CategoryPage";
import Checkout from "./pages/Checkout"; 
import OrderConfirmation from "./pages/OrderConfirmation";
import Footer from "./components/Footer";
import AdminPanel from "./pages/AdminPanel";
import About from "./pages/About";
const App = () => {
  const [user, setUser] = useState(null);
  const { cartCount } = useContext(CartContext) || { cartCount: 0 };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  };

  return (
    // Contenedor flex con altura mínima de pantalla
    <div className="flex flex-col min-h-screen">
      {/* Navbar fijo arriba */}
      <Navbar user={user} onLogout={handleLogout} cartCount={cartCount} />

      {/* Contenido principal que crece */}
      <div className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login setUser={setUser} />} />
          <Route path="/register" element={<Register setUser={setUser} />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/search" element={<SearchResults />} />
          <Route path="/brand" element={<BrandList />} />
          <Route path="/checkout" element={<Checkout user={user} />} />
          <Route path="/order-confirmation" element={<OrderConfirmation />} />
          <Route path="/admin/*" element={<AdminPanel />} />
          <Route path="/brand/:brandName" element={<BrandProducts />} />
          <Route path="/category/:categoryName" element={<CategoryPage />} />
          <Route path="/product/:id" element={<ProductPage />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </div>

      {/* Botón flotante del carrito */}
      <FloatingCartButton />

      {/* Footer al final */}
      <Footer />
    </div>
  );
};

export default App;
